<template>
  <div>
    <div :class="['reservation-notes-modal', {show: modal}]" @click="closeModal">
      <div class="reservation-notes-modal-container">
        <div class="reservation-notes-modal-content" @click.stop>
          <b class="lr-title">Daily Reservation Report</b>

          <label class="lr-label">Select Date:</label>
          <datepicker class="datepicker" v-model="date" format="MMMM dd, yyyy"></datepicker>

          <div class="download-type">
            <label :class="['pdf', {'has-error':error.format}]">
              <input type="checkbox" name="downloadType" v-model="pdfChecked" />
              PDF
            </label>
            <label :class="['csv', {'has-error':error.format}]">
              <input type="checkbox" name="downloadType" v-model="csvChecked" />
              CSV
            </label>
          </div>

          <div class="error" v-show="error.msg" v-html="error.msg"></div>

          <a :class="['button cta success small block generate', {disabled: loading}]" @click="generate">
            <span v-if="loading">
              <i class="fa fa-spinner fa-spin" v-show="loading"></i> Generating Report...
            </span>
            <span v-else>Generate and Download Report</span>
          </a>
        </div>
      </div>
    </div>

    <div id="pdf-view" >
      <div class="page-daily">
        <div class="title">Opoli Daily Reservation Report</div>
        <div class="date-range">{{ dateFormat(date) }}</div>
        <table>
          <thead>
            <tr class="table-heading">
              <th>Brand</th>
              <th>Daily<br/>RSVP</th>
              <th>Daily<br/>Goal</th>
              <th>Total Amount<br/>Daily</th>
              <th>Weekly<br/>RSVP</th>
              <th>Weekly<br/>Goal</th>
              <th>Total Amount<br/>Weekly</th>
              <th>Avg<br/>Fare</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in pdf.list" :key="index">
              <td>{{data.brand}}</td>
              <td class="center">{{data.dailyRsvp}}</td>
              <td class="center">{{data.dailyGoal}}</td>
              <td class="center">{{data.dailyTotal}}</td>
              <td class="center">{{data.weeklyRsvp}}</td>
              <td class="center">{{data.weeklyGoal}}</td>
              <td class="center">{{data.weeklyTotal}}</td>
              <td class="center">{{data.avgFare}}</td>
            </tr>

            <tr class="total">
              <td>Total</td>
              <td class="center">{{ pdf.total.totalDailyRsvp }}</td>
              <td></td>
              <td class="center">${{ pdf.total.totalDailyAmount }}</td>
              <td class="center">{{ pdf.total.totalWeeklyRsvp }}</td>
              <td></td>
              <td class="center">${{ pdf.total.totalWeeklyAmount }}</td>
              <td class="center"><!--${{ pdf.total.totalAvgFare }}--></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import CsvExport from 'csvexport'

export default {
  name: 'daily-rsvp-report',
  props: ['modal'],
  components: { datepicker },
  data () {
    return {
      loading: false,
      date: null,
      pdfChecked: true,
      csvChecked: false,
      error: {
        msg: '',
        format: ''
      },
      pdf: {
        list: [],
        total: {}
      },
      csv: {
        label: [],
        data: [],
        list: [],
        total: {},
        summaryWeeklyLabel: [],
        terminalLabel: []
      },
      isIOS: navigator.userAgent.match(/(iPad|iPhone|iPod)/g)
    }
  },
  computed: {
  },
  methods: {
    generate () {
      let self = this
      if (self.loading) return

      self.error.msg = ''
      let hasError = false
      if (!self.date) {
        self.error.msg = 'Please select a date.'
        hasError = true
      }
      if (!self.pdfChecked && !self.csvChecked) {
        if (self.error.msg) self.error.msg += '<br/>'
        self.error.msg += 'Please select which file format.'
        hasError = true
      }
      if (hasError) return

      self.loading = true
      let date = moment(this.date)
      self.$sdk.get('/reports/brands/date', {
        token: this.$store.state.session.sessionToken,
        date: date.format('YYYY-MM-DD'),
        since: date.startOf('isoWeek').format('YYYY-MM-DD'),
        until: date.endOf('isoWeek').format('YYYY-MM-DD')
      }, res => {
        self.loading = false
        if (!res.brands.length) {
          self.error.msg = 'Empty Result.'
          return
        }

        let totalDailyRsvp = 0
        let totalDailyAmount = 0
        let totalWeeklyRsvp = 0
        let totalWeeklyAmount = 0
        let totalAvgFare = 0

        this.pdf.list = []
        this.pdf.total = {}
        res.brands.forEach(brand => {
          totalDailyRsvp += brand.dailyRsvp
          totalDailyAmount += brand.dailyTotal
          totalWeeklyRsvp += brand.weeklyRsvp
          totalWeeklyAmount += brand.weeklyTotal
          totalAvgFare += brand.avgFare

          this.pdf.list.push({
            brand: brand.brandName,
            dailyRsvp: this.covertNumber(brand.dailyRsvp),
            dailyTotal: this.covertNumber(brand.dailyTotal.toFixed(2)),
            dailyGoal: this.goal(brand.brandId, 'daily'),
            weeklyRsvp: this.covertNumber(brand.weeklyRsvp),
            weeklyTotal: this.covertNumber(brand.weeklyTotal.toFixed(2)),
            weeklyGoal: this.goal(brand.brandId, 'weekly'),
            avgFare: this.covertNumber(brand.avgFare.toFixed(2)),
          })
        })

        this.pdf.total = {
          totalDailyRsvp: this.covertNumber(totalDailyRsvp),
          totalDailyAmount: this.covertNumber(totalDailyAmount.toFixed(2)),
          totalWeeklyRsvp: this.covertNumber(totalWeeklyRsvp),
          totalWeeklyAmount: this.covertNumber(totalWeeklyAmount.toFixed(2)),
          totalAvgFare: this.covertNumber((totalAvgFare / 7).toFixed(2)),
        }

        if (self.pdfChecked) {
          self.processPdf()
        } else {
          self.processCsv()
        }
      })
    },
    covertNumber (value) { return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") },
    goal (id, type) {
      let index = CONFIG.brands.findIndex(x => x.id === id)
      if (index == -1) return '--'
      let brand = CONFIG.brands[index].code
      switch (brand) {
        case 'op': return type === 'daily' ? 30 : 210
        case 'gs': return type === 'daily' ? 30 : 210
        case 'pts': return type === 'daily' ? 300 : 2100
        case 's2l': return type === 'daily' ? 100 : 700
        default: return type === 'daily' ? '--' : '--'
      }
    },
    processPdf () {
      let self = this
      let date = moment(self.date)
      let pageAsyncs  = []
      // let landscapeReports = self.orientation
      // let orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p'
      let orientation = 'l'
      let pdf = new jsPDF({ orientation: orientation, unit: 'mm', format: 'a4' })

      window.scrollTo(500, 0)
      document.body.style.overflow = 'hidden'

      setTimeout(() => {
        pageAsyncs.push(html2canvas(document.getElementsByClassName('page-daily')[0], {
          scale: "1"
        }).then(canvas => {
          let imgData = canvas.toDataURL('image/jpeg', 0.9)
          pdf.addImage(imgData, 'JPEG', 0, 0)
        }).catch(e => {
          self.error.msg = 'Something went wrong generating pdf.'
          document.body.style.overflow = 'auto'
          console.warn(e)
        }))
        Promise.all(pageAsyncs).then(() => {
          let timestamp = date.format('YYYYMMDD')
          pdf.save(`daily-rsvp-report_${timestamp}.pdf`)
          document.body.style.overflow = 'auto'
          self.processCsv()
        })
      }, 2000)
    },
    processCsv () {
      if (!this.csvChecked) return
      let timestamp = moment(this.date).format('YYYYMMDD')
      const exporter = CsvExport.create({
        filename: `daily-rsvp-report_${timestamp}.csv`,
        columns: [
          'Brand', 'Daily Rsvp',
          'Daily Goal', 'Total Amount Daily',
          'Weekly Rsvp', 'Weekly Goal',
          'Total Amount Weekly', 'Avg Fare'
        ]
      })

      let data = []
      this.pdf.list.forEach(x => {
        data.push({
          'Brand': x.brand,
          'Daily Rsvp': x.dailyRsvp,
          'Daily Goal': x.dailyGoal,
          'Total Amount Daily': x.dailyTotal,
          'Weekly Rsvp': x.weeklyRsvp,
          'Weekly Goal': x.weeklyGoal,
          'Total Amount Weekly': x.weeklyTotal,
          'Avg Fare': x.avgFare,
        })
      })
      data.push({
        'Brand': 'Total',
        'Daily Rsvp': this.pdf.total.totalDailyRsvp,
        'Daily Goal': '',
        'Total Amount Daily': this.pdf.total.totalDailyAmount,
        'Weekly Rsvp': this.pdf.total.totalWeeklyRsvp,
        'Weekly Goal': '',
        'Total Amount Weekly': this.pdf.total.totalWeeklyAmount,
        'Avg Fare': this.pdf.total.totalAvgFare
      })

      // add total
      exporter.downloadCsv(data)
    },
    closeModal () {
      if (this.loading) return
      this.$emit('closeDailyRsvp')
    },
    dateFormat (x) { return moment(x).format('MM/DD/YYYY') }
  },
  mounted () {

  }
}
</script>

<style lang="scss" scoped>
.reservation-notes-modal {
  position: fixed;
  z-index: 999;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  display: table;
  opacity: 0;
  transition: all 250ms;

  &.show{
    top: 0;
    opacity: 1;
  }
}
.reservation-notes-modal-container {
  display: table-cell;
  vertical-align: middle;
}
.reservation-notes-modal-content {
  background-color: #fff;
  border-radius: 3px;
  max-width: 400px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  text-align: center;
  padding: 20px;
}

.lr-title{
  font-size: 16px;
  margin-bottom: 20px;
  display: block;
}
.lr-label{
  display: block;
  text-align: left;
  margin-bottom: 2px;
  font-size: 14px;
  color: #777;
  display: block;
}

.download-type{
  width: 100%;
  padding-bottom: 5px;
  margin-top: 10px;

  label{
    cursor: pointer;
    display: inline-block;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    padding: 2px 20px;
    border:1px solid #ddd;

    &.pdf{ color: #c54d4d; }
    &.csv{ color: #7ad275; }
    &.has-error{ border: 1px solid #d00; }
    input{
      display: inline;
      margin-top: 0;
      width: auto;
      vertical-align: -1px;
    }
  }
}

.generate{
  margin-top: 10px;
}
.error{
  background-color: #F25E0D;
  font-size: 14px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  padding: 5px;
  margin-top: 10px;
}

#pdf-view{
  position: fixed;
  top: 0%;
  right: 100%;
  width: 1122px;
  height: 793px;
  // width: 793px;
  // height: 1122px;
  background: #fff;
  z-index: -1;

  .page-daily{
    padding: 30px;
    position: relative;
    width: 100%;
    height: 100%;

    .page-count{
      position: absolute;
      bottom: 10px;
      right: 30px;
      color: #aaa;
      font-size: 12px;
      text-align: right;
      font-style: italic;
    }
  }
  .title{
    text-align: center;
    font-weight: 600;
    font-size: 21px;
  }
  .date-range{
    text-align: center;
    font-style: italic;
    font-size: 18px;
    margin-bottom: 20px;
    color: #555;
  }

  table{
    width: 100%;
    font-size: 12px;
    border-collapse: collapse;

    thead{
      font-weight: 600;
      tr:last-child th{ border-bottom: 1px solid #333; }
    }
    tbody{
      tr{
        &.subtotal, &.total{ font-weight: 700; }
        &.total{
          color: #000;
          font-size: 15px;
          border-top: 1px solid #333;
        }
      }
      td{ padding: 2px 3px; }
      .center{
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Reports/DailyRsvpReport.vue